import { FilterValue } from "../Filters/FilterValue";

export const OrderType: FilterValue[] = [
  // { id: "0", value: "" },
  { id: "1", value: "Normal" },
  { id: "2", value: "Unpaid" },
  { id: "3", value: "Event" },
  { id: "4", value: "Storage" },
  { id: "5", value: "Paid Sample" },
  { id: "6", value: "Hybrid" },
  { id: "7", value: "POD" },
];
